import messengers from './messengers';
import social_links from './social';

const sublinksScheme = {
  messengers,
  social_links
};

export default sublinksScheme;


// WEBPACK FOOTER //
// ./src/components/SmartLinks/schemes/index.js